import { computed } from 'vue'
import { SelectOption } from '@/dto/common'
import { useDashboard } from '@/store/Dashboard'
import { CommonCountryResponseDto } from '@/dto/common/Country/Response'
import { getCountries } from '@/api/common'

export function useCountries() {
  const dashboardStore = useDashboard()

  const countries = computed<CommonCountryResponseDto[]>(() => {
    return dashboardStore.getters.countries
  })

  const localeCountry = computed<CommonCountryResponseDto | undefined>(() => {
    return countries.value.find((c) => c.iso_alpha_2 === dashboardStore.getters.localeCountry)
  })

  const countryOptions = computed<SelectOption[]>(() =>
    countries.value.map((c) => ({
        label: c.name,
        value: c.id
      })
    )
  )

  async function updateCountries() {
    await loadCountries(true)
  }

  // private
  const loadCountries = async (force = false) =>  {
    try {
      if (force || countries.value.length === 0) {
        const { data } = await getCountries()
        dashboardStore.dispatch('setCountries', data.data)
      }
    } catch {}
  }

  loadCountries()

  return {
    countries,
    countryOptions,
    updateCountries,
    localeCountry
  }
}
